import { render, staticRenderFns } from "./Somos1V2UserRegionAccessComponent.vue?vue&type=template&id=31d06737&scoped=true"
import script from "./Somos1V2UserRegionAccessComponent.vue?vue&type=script&lang=js"
export * from "./Somos1V2UserRegionAccessComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d06737",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d06737')) {
      api.createRecord('31d06737', component.options)
    } else {
      api.reload('31d06737', component.options)
    }
    module.hot.accept("./Somos1V2UserRegionAccessComponent.vue?vue&type=template&id=31d06737&scoped=true", function () {
      api.rerender('31d06737', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1V2/page/Somos1V2RegionalIndicators1Page/Somos1V2UserRegionAccessComponent.vue"
export default component.exports